// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__rAc8C","logo":"styles_logo__5KTAY","cardHead":"styles_cardHead__8ycIO","cardItems":"styles_cardItems__8L9No","button":"styles_button__LtYBL"};